var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06408 0.21207C5.13878 0.302773 5.18454 0.413778 5.19545 0.53074C5.20636 0.647702 5.18193 0.765247 5.1253 0.868187C4.68288 1.6799 4.45184 2.58976 4.45342 3.51407C4.45342 6.58895 6.96187 9.07883 10.0534 9.07883C10.4567 9.07883 10.8493 9.03678 11.2265 8.95648C11.3422 8.93145 11.4626 8.94103 11.5729 8.984C11.6831 9.02698 11.7782 9.10145 11.8464 9.19813C11.9183 9.29865 11.955 9.4201 11.9507 9.5436C11.9464 9.6671 11.9014 9.78572 11.8226 9.88101C11.2225 10.6178 10.4653 11.2114 9.6064 11.6186C8.74748 12.0258 7.80846 12.2363 6.85779 12.2348C3.33005 12.2348 0.472656 9.39466 0.472656 5.89536C0.472656 3.26172 2.09037 1.00278 4.39373 0.0453638C4.50847 -0.00309416 4.63584 -0.0130399 4.75672 0.0170205C4.8776 0.047081 4.98545 0.115525 5.06408 0.21207V0.21207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMoon);
export default __webpack_public_path__ + "static/media/white_moon.71048c66c6dd77748e37710006076db8.svg";
export { ForwardRef as ReactComponent };